import React from 'react'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function BackButton({ to }: { to?: string }) {
	const navigate = useNavigate()

	const handleClick = (e: React.MouseEvent) => {
		// If history exists, go back one step. Otherwise navigate to `to` or '/'
		e.preventDefault()
		if (window.history.length > 1) {
			navigate(-1)
		} else {
			navigate(to ?? '/')
		}
	}

	return (
		<button
			type="button"
			onClick={handleClick}
			className="flex cursor-pointer items-center self-start text-sm text-white/80 hover:text-white lg:absolute lg:top-8"
			aria-label="Go back"
		>
			<ArrowLeft size={12} className="mr-2" /> Back
		</button>
	)
}
